import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React from 'react';

import { LocalForm } from 'react-redux-form';

import Alert from '../../container/Alert';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import replaceID from '../../../utility/replaceID';
import steps from '../../../data/assesment-steps';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'assessment.header.title',
    description: 'Page Header Title',
    defaultMessage: 'Free Assessment'
  },
  headerSubTitle: {
    id: 'assessment.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Upload files for translation free assessment.'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

const Thankspage = props => {
  const { intl } = props;
  //const fileList = project.files;

  return (
    <div className="preview page">
      <Helmet>
        <title>{intl.formatMessage(messages.htmlHeader)} - Shift</title>
      </Helmet>
      <Header
        title={intl.formatMessage(messages.headerTitle)}
        subtitle={intl.formatMessage(messages.headerSubTitle)}
        //steps={replaceID(steps, project.projectId)}
        steps={replaceID(steps, '4')}
        selectedStep={3}
        icon="preview"
        locale={props.locale}
      />
      <Alert
        title={intl.formatMessage(messages.htmlHeader)}
        message={print(props.status)}
      />
      <div className="main">
        <div
          className="panel"
          style={{
            width: '60%',
            padding: '40px',
            boxSizing: 'content-box',
            marginTop: '15px',
            display: 'block',
            alignContent: 'center',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <LocalForm onSubmit={props.onSubmit}>
            <div className="form">
              <table>
                <tr>
                  <td style={{ width: '85%' }}>
                    <label
                      style={{
                        width: '90%',
                        fontSize: '16px',
                        textTransform: 'none',
                        lineHeight: '150%'
                      }}
                    >
                      Thank you. You will receive a confirmation email/text
                      shortly. If you do not receive, please contact us. A
                      dedicated engineer will be assigned and will contact you
                      within 1 business day.
                    </label>
                  </td>
                  <td>
                    <div
                      className="button-container"
                      style={{
                        display: 'inline',
                        alignContent: 'right'
                      }}
                    >
                      <button
                        className="button"
                        onClick={() => props.clickFAQHandler('1')}
                      >
                        <FormattedMessage
                          id="assessment.need.help.button.name"
                          defaultMessage="UpNeed Help ?"
                        />
                      </button>
                    </div>
                  </td>
                </tr>
              </table>
              <br />
              <br />
              <div className="button-container" style={{ textAlign: 'center' }}>
                <button
                  className="button"
                  styel={{ padding: 20 }}
                  onClick={() => props.clickLogoffHandler()}
                >
                  <FormattedMessage
                    id="logoff.button.name"
                    defaultMessage="Logoff"
                  />
                </button>
              </div>
            </div>
          </LocalForm>
        </div>
      </div>
    </div>
  );
};

Thankspage.propTypes = {};

export default injectIntl(Thankspage);



// WEBPACK FOOTER //
// ./src/components/views/Thankspage/index.js